import { useCallback } from 'react';

import { useSegment } from '@telialt/utils/src/segment';

import { ESHOP_MUTATION_KEY } from '../../model';
import { apiRemoveProduct } from '../../store/api';
import { useCartQuery } from '../queries/useCartQuery';
import { useMutationWithCartRefresh } from './useMutationWithCartRefresh';

type ProductMutation = {
    entryNumber: number;
};

export const useRemoveProductMutation = () => {
    const segment = useSegment();
    const { cartId } = useCartQuery();

    const { mutate, isPending, error } = useMutationWithCartRefresh(
        async ({ entryNumber }: ProductMutation) => {
            const { data: cart } = await apiRemoveProduct(segment, { entryNumber, cartId });

            return cart;
        },
        {
            mutationKey: [ESHOP_MUTATION_KEY.DELETE_CART_ENTRY],
        },
    );

    // Keeping same interface as previously used removeProductAction to avoid refactorings.
    const onMutate = useCallback((entryNumber: number) => mutate({ entryNumber }), [mutate]);

    return {
        removeProduct: onMutate,
        removeProductIsLoading: isPending,
        removeProductError: error,
    };
};
